import { createSession } from '../../../lib/api'
import moment from 'moment'

export const createGroupObject = async (users, self, name) => {
  const session = {
    assigned_to: null,
    name: name !== '' ? name : null,
    state: 'ACTIVE',
    profile: 'PRIVATE',
    userIds: [...users.map(u => u.id), self],
    owner_id: null,
    // closed_at: null,
    closedAt: null, // TODO: Remove
    // ended_at: null,
    topic: null,
    inbox_id: null
  }

  const newSession = await createSession(session)
  return newSession
}

export const createSessionObject = async (userIds, topic, self, owner) => {
  const session = {
    assigned_to: self,
    name: null,
    state: 'ACTIVE',
    profile: 'PUBLIC_CLOSED',
    userIds: userIds,
    owner_id: owner,
    // closed_at: null,
    closedAt: null, // TODO: remove
    // ended_at: null,
    topic: topic ?? null,
    // TODO: Remove this later
    inbox_id: '00000000-0000-4b00-8157-000000000001'
  }

  return session
}

export const createSessionObjectV2 = async (
  userIds,
  topic,
  self,
  owner,
  inbox_id
) => {
  const session = {
    assigned_to: self,
    name: null,
    state: 'ACTIVE',
    profile: 'PUBLIC_CLOSED',
    userIds: userIds,
    owner_id: owner,
    closedAt: null, // TODO: remove
    topic: topic ?? null,
    inbox_id: inbox_id
  }

  return session
}
// check to use message or note's date
export const dateVariable = obj => {
  let date = obj.messages[0].date

  if (obj.notes?.length > 0) {
    if (new Date(obj.messages[0].date) < new Date(obj.notes[0].date)) {
      date = obj.notes[0]?.date
    }
  }

  return date
}

// compares date by lastest message
export const newestDateComparator = (a, b) => {
  if (!a.messages?.length) {
    return
  }

  if (!a?.messages[0] || !b?.messages[0]) {
    return moment(b.lastUpdate) - moment(a.lastUpdate)
  } else {
    // check to use note or message for sort
    const first = dateVariable(a)
    const second = dateVariable(b)

    return moment(second) - moment(first)
  }
}

// compares date by lastest message
export const oldestDateComparator = (a, b) => {
  if (!a?.messages[0] || !b?.messages[0]) {
    return moment(a.lastUpdate) - moment(b.lastUpdate)
  } else {
    // check to use note or message for sort
    const first = dateVariable(a)
    const second = dateVariable(b)

    return moment(first) - moment(second)
  }
}

// removes extra keys for update session
export const formatUpdateSession = (session, close) => {
  // Filter out values we can send to api
  const {
    name,
    topic,
    profile,
    owner_id,
    tags,
    inboxId,
    inbox_id,
    assigned_to
  } = session

  // Update state since this session is now active
  const addAssignedTo = {
    name,
    topic: topic ?? null,
    state: close ? 'ENDED' : 'ACTIVE',
    profile,
    owner_id,
    tags,
    assigned_to,
    // closed_at: session.closed_at ?? null,
    // TODO: Remove this line later
    closedAt: session.closed_at ?? null,
    inbox_id: inboxId ?? inbox_id
  }

  return addAssignedTo
}
